import React from "react";
import s from "./CustomTable.module.scss";
import { Link } from "react-router-dom";
import ArrowRight from "../../../../../../global components/Icons/ArrowRight";
import clsx from "clsx";
import { Skeleton } from "antd";
type PropType = {
  tableTitle: string;
  columns: string[];
  data: { colOne: string; colTwo: string; colThree: string }[];
  isLoading: boolean;
  path: string;
};
function CustomTable({ tableTitle, columns, data, isLoading, path }: PropType) {
  return (
    <Link to={path} className={s.link}>
      <div className={s.wrapper}>
        <div className={s.head}>
          <h5 className={s.title}>{tableTitle}</h5>
          <ArrowRight className={s.icon} />
        </div>
        <div className={s.body}>
          <table className={s.table}>
            <thead>
              {columns.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </thead>
            {isLoading ? (
              <tbody>
                {Array.from({ length: 5 }).map((_, index) => (
                  <tr key={index}>
                    <td>
                      <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 1, width: "100%" }}
                      />
                    </td>
                    <td>
                      <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 1, width: "100%" }}
                      />
                    </td>
                    <td>
                      <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 1, width: "100%" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    {" "}
                    <td>{item.colOne}</td> <td>{item.colTwo}</td>{" "}
                    <td>
                      <p
                        className={clsx({
                          [s.active]: item.colThree
                            .toLowerCase()
                            .includes("active"),
                          [s.inactive]: item.colThree
                            .toLowerCase()
                            .includes("inactive"),
                          [s.revoked]: item.colThree
                            .toLowerCase()
                            .includes("revoked"),
                        })}
                      >
                        {" "}
                        {item.colThree}
                      </p>
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </Link>
  );
}

export default CustomTable;
